import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import ValidationErrorToast from '../../components/validationErrorToast';
import SuccessToast from '../../components/successToast';
import ARAssistant from '../../components/ARAssistant/ARAssistant';

// --- Constants ---
const AVAILABLE_VOICES = [
    { id: 'aGkVQvWUZi16EH8aZJvT', name: 'Steve (Default)', desc: '', default: true, url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/aGkVQvWUZi16EH8aZJvT/hUdpJvUH4knIjWwEeGyu.mp3'},
    { id: 'gZ25QC7GHcbM4iwAqulk', name: 'Tim', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/UqlmS3fqKkPB3Kxe6l43H9rmZBr1/voices/gZ25QC7GHcbM4iwAqulk/tjbX787FFYkEx6ZBk7Jy.mp3'},
    { id: '319bKIhetA5g6tmywrwj', name: 'Gemma', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/B6XKo1XG4CdCYGvSECuh2iFjzTq1/voices/319bKIhetA5g6tmywrwj/f40d37fb-ac3b-4914-aaf8-f79ff1e40563.mp3'},
    { id: 'JGIWhSd306fVRtZfD1OA', name: 'Alex', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/q8zuFD4ZjXYZNb8cWTy9Ou0CtaL2/voices/JGIWhSd306fVRtZfD1OA/22ec892b-347f-48dc-9acd-a6d846f31f89.mp3'},
    { id: 'd9rRtAT3qedrNbvmbykg', name: 'Will', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/d9rRtAT3qedrNbvmbykg/jvwceYyY7TMLBHNNRuFF.mp3'},
    { id: 'MiueK1FXuZTCItgbQwPu', name: 'Maya', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/MiueK1FXuZTCItgbQwPu/dY0JGbhvAH2WTEuoj9Bu.mp3'},
    { id: 'M7ya1YbaeFaPXljg9BpK', name: 'Hannah Jayne', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/7tvaSRybYYZ7ja2RTmrVkfJ75f93/voices/M7vaSRybYYZ7ja2RTmrVkfJ75f93/voices/M7ya1YbaeFaPXljg9BpK/8Wc09F9557roFsMSjG9E.mp3'},
    { id: '2nzji8yPQooBwG4eQO4s', name: 'John C', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/65SEE4Sx3cgZtuy8loIdatKOCAP2/voices/2nzji8yPQooBwG4eQO4s/IIzySX64Ezkj4ylWqrl5.mp3'},
    { id: 'NihRgaLj2HWAjvZ5XNxl', name: 'Matilda', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/NihRgaLj2HWAjvZ5XNxl/OrIdbMk7IHZvEOEVlsQ0.mp3'},
    { id: 'sai9UY7iXkRDSsXHR0bZ', name: 'Ben', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/IbGEr7k62hYnUndiEtdtV54pnbs1/voices/sai9UY7iXkRDSsXHR0bZ/5NrxCi9pzZbyENe8FAo9.mp3'},
    { id: 'HDA9tsk27wYi3uq0fPcK', name: 'Stuart', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/3LUrnzimItRhFJyBGCNQfSc602Y2/voices/HDA9tsk27wYi3uq0fPcK/4AhIQcGzr8aDvnONN3bh.mp3'},
    { id: 'p43fx6U8afP2xoq1Ai9f', name: 'Emily', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/custom/voices/p43fx6U8afP2xoq1Ai9f/zs7hPpzFI1bDorvMkY1S.mp3'},
    { id: 'mWNaiDAPDAx080ro4nL5', name: 'Baz', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/4jd2taMCJEbpEc9UOOIkqbnr25f2/voices/mWNaiDAPDAx080ro4nL5/KpqGhJNeegsctFx6I88k.mp3'},
    { id: 'v7AjIzCg6vdhCmXwBrb1', name: 'Ian', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/ewdfKQmq34ecRnjie0F9o1SFEFs2/voices/v7AjIzCg6vdhCmXwBrb1/bXYrWiWIErO8NxtmqRi4.mp3'},
    { id: 'sx8pHRzXdQfuUYPGFK7X', name: 'Anna', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/Ib8YRLFGZcfUWFZbcvIMMjy0fv93/voices/sx8pHRzXdQfuUYPGFK7X/yp6G4CygiVVHU2jFJHLK.mp3'},
    { id: 'nBoLwpO4PAjQaQwVKPI1', name: 'Amelia', desc: '', url: 'https://storage.googleapis.com/eleven-public-prod/database/user/zMfVYhWBQcWhDcafePbjm8CD5Lx2/voices/nBoLwpO4PAjQaQwVKPI1/pEX4zUYPQmsyqSF5AcW4.mp3'},
];
const DEFAULT_VOICE_ID = AVAILABLE_VOICES.find(v => v.default)?.id || AVAILABLE_VOICES[0]?.id || '';

const PERSONALITY_TYPES = [
    { id: 'professional', name: 'Professional', description: 'Formal and business-like' },
    { id: 'friendly', name: 'Friendly', description: 'Warm and approachable' },
    { id: 'empathetic', name: 'Empathetic', description: 'Understanding and compassionate' },
    { id: 'assertive', name: 'Assertive', description: 'Direct and confident' },
    { id: 'diplomatic', name: 'Diplomatic', description: 'Tactful and considerate' },
];
const DEFAULT_PERSONALITY_ID = PERSONALITY_TYPES[0]?.id || '';

const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const PRE_DUE_DATE_REMINDER_OPTIONS = [1, 2, 3, 5, 7]; // Days

// --- Interfaces ---
interface Shift {
    enabled: boolean;
    startTime: string;
    endTime: string;
    voiceId: string;
    personalityId: string;
}

interface DaySchedule {
    day: string;
    shifts: [Shift, Shift];
}

interface PersonalityOverride {
    enabled: boolean;
    daysPastPaymentTerms: number;
    personalityId: string;
}

interface ARSettingsRouteParams {
    organizationId: string;
}

interface ARSettingsProps extends RouteComponentProps<ARSettingsRouteParams> {}

// --- Styles (Adjusted for Compactness and Scrolling) ---
const styles: { [key: string]: React.CSSProperties } = {
    container: { backgroundColor: '#F8F9FA', minHeight: '100vh', display: 'flex', flexDirection: 'column' },
    topBar: {
        background: '#FFFFFF', borderBottom: '1px solid #E0E0E0', padding: '12px 20px', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px',
    },
    topBarTitle: { color: '#141414', margin: 0, fontSize: '22px', fontWeight: '500' },
    backButton: {
        padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex',
        alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: '500',
        backgroundColor: '#FFFFFF', color: '#0065FF', border: '1px solid #0065FF', transition: 'background-color 0.2s ease',
    },
    blueBox: {
        background: '#FFFFFF', border: '1px solid #E0E0E0', borderRadius: '10px', padding: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '20px',
    },
    sectionTitle: {
        color: '#141414', fontSize: '18px', fontWeight: '600', marginBottom: '16px',
        display: 'flex', alignItems: 'center', gap: '10px',
        borderBottom: '1px solid #E0E0E0', paddingBottom: '10px',
    },
    collapsibleSectionTitle: {
        cursor: 'pointer', userSelect: 'none',
    },
    arrowIcon: {
        transition: 'transform 0.3s ease',
        fontSize: '14px',
    },
    arrowIconExpanded: {
        transform: 'rotate(90deg)',
    },
    whiteText: { color: '#141414' },
    mutedText: { color: '#555555', fontSize: '12px' },
    label: {
        color: '#555555', marginBottom: '6px', display: 'block',
        fontSize: '13px', fontWeight: '500',
    },
    input: {
        width: '100%', padding: '8px 12px', fontSize: '13px', color: '#242424',
        backgroundColor: '#FFFFFF', border: '1px solid #D1D1D1',
        borderRadius: '5px', outline: 'none', marginBottom: '12px',
    },
    textarea: { minHeight: '80px', resize: 'vertical' },
    select: {
        width: '100%', padding: '8px 12px', fontSize: '13px', color: '#242424',
        backgroundColor: '#FFFFFF', border: '1px solid #D1D1D1',
        borderRadius: '5px', outline: 'none', cursor: 'pointer', marginBottom: '12px',
    },
    selectOption: { backgroundColor: '#FFFFFF', color: '#242424' },
    switchContainer: { display: 'flex', alignItems: 'center', marginBottom: '12px', justifyContent: 'space-between' },
    switchLabelText: { color: '#555555', fontSize: '13px', marginRight: '10px' },
    switch: { position: 'relative', display: 'inline-block', width: '44px', height: '24px' },
    switchInput: { opacity: 0, width: 0, height: 0 },
    switchSlider: {
        position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: '#D1D1D1', borderRadius: '24px', transition: '0.4s',
    },
    switchSliderChecked: { backgroundColor: '#0065FF' },
    switchKnob: {
        position: 'absolute', content: '""', height: '18px', width: '18px',
        left: '3px', bottom: '3px', backgroundColor: 'white', borderRadius: '50%', transition: '0.4s',
    },
    switchKnobChecked: { transform: 'translateX(20px)' },
    button: {
        padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
        fontSize: '13px', fontWeight: '500',
        transition: 'background-color 0.2s ease, opacity 0.2s ease, transform 0.1s ease',
        lineHeight: '1.2',
    },
    primaryButton: { backgroundColor: '#0065FF', color: '#FFFFFF' },
    previewButton: {
        backgroundColor: '#FFFFFF', color: '#0065FF',
        border: '1px solid #0065FF', padding: '6px 10px', marginLeft: '8px',
    },
    timetableDayRow: {
        display: 'flex', alignItems: 'flex-start', padding: '12px 0',
        borderBottom: '1px solid #E0E0E0', gap: '12px',
    },
    timetableDayLabel: {
        color: '#141414', fontWeight: '600', fontSize: '14px', width: '100px',
        flexShrink: 0, paddingTop: '8px',
    },
    timetableShiftsWrapper: { display: 'flex', flexDirection: 'column', gap: '12px', flexGrow: 1 },
    timetableShiftContainer: { padding: '12px', background: '#F8F9FA', border: '1px solid #E0E0E0', borderRadius: '6px' },
    timetableShiftHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
    timetableShiftControls: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '10px' },
    timeInput: {
        padding: '6px 8px', fontSize: '13px', color: '#242424',
        backgroundColor: '#FFFFFF',
        border: '1px solid #D1D1D1', borderRadius: '5px', width: '100%'
    },
    validationErrorBox: {
        background: '#F8D7DA', border: '1px solid #F5C2C7',
        borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', color: '#842029',
    },
    validationErrorList: { margin: 0, paddingLeft: '18px', fontSize: '13px' },
    loadingOverlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000,
    },
    saveButtonContainer: {
        display: 'flex', justifyContent: 'flex-end', marginTop: '24px',
        paddingTop: '16px', borderTop: '1px solid #E0E0E0',
    },
    infoText: { fontSize: '13px', color: '#555555', marginBottom: '12px', lineHeight: 1.5 },
    formRow: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
    formCol: { flex: '1 1 calc(50% - 10px)', minWidth: '300px' },
    overrideTier: { border: '1px solid #E0E0E0', padding: '12px', borderRadius: '6px', marginBottom: '12px'},
    subSectionTitle: { color: '#141414', fontSize: '15px', fontWeight: '500', marginTop: '20px', marginBottom: '12px', borderBottom: '1px solid #E0E0E0', paddingBottom: '8px' },
};

// --- ToggleSwitch Component ---
const ToggleSwitch = ({ isOn, handleToggle, disabled = false, label }) => {
    return (
        <div style={styles.switchContainer} onClick={(e) => { if (disabled) e.preventDefault(); else handleToggle(); }}>
            <span style={styles.switchLabelText}>{label}</span>
            <div style={{ ...styles.switch, cursor: disabled ? 'not-allowed' : 'pointer' }}>
                <input type="checkbox" checked={isOn} disabled={disabled} onChange={() => {}} style={styles.switchInput} />
                <span style={{ ...styles.switchSlider, ...(isOn ? styles.switchSliderChecked : {}), ...(disabled ? { opacity: 0.5 } : {}) }}>
                    <span style={{ ...styles.switchKnob, ...(isOn ? styles.switchKnobChecked : {}) }} />
                </span>
            </div>
        </div>
    );
};



// --- A beautiful little modal component, just for you ---
// --- Replace your existing AddNumberModal component with this one ---

const AddNumberModal = ({ isOpen, onClose, onAdd }) => {
    // A sample list of available numbers. In a real app, you'd fetch this!
    const AVAILABLE_NUMBERS = [
        '+61483945721',
        '+61483945722',
        '+61483945723',
        '+61483945724',
        '+61483945725',
    ];

    const [selectedNumber, setSelectedNumber] = useState(AVAILABLE_NUMBERS[0]);
    const [description, setDescription] = useState('');

    useEffect(() => {
        // Reset state when modal opens
        if (isOpen) {
            setSelectedNumber(AVAILABLE_NUMBERS[0]);
            setDescription('');
        }
    }, [isOpen]); // This effect depends on AVAILABLE_NUMBERS, but it's constant here.

    if (!isOpen) return null;

    const handleAdd = () => {
        if (selectedNumber && description.trim()) {
            onAdd({ number: selectedNumber, description });
            onClose();
        } else {
            ValidationErrorToast("Missing Info", "Please provide a description for the number.");
        }
    };

    const modalStyles: { [key: string]: React.CSSProperties } = {
        overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10001 },
        modal: { background: '#FFFFFF', border: '1px solid #E0E0E0', padding: '25px', borderRadius: '10px', width: '90%', maxWidth: '500px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' },
        header: { color: '#141414', fontSize: '18px', fontWeight: '600', marginBottom: '20px' },
        costNote: {
            backgroundColor: '#FFF3CD',
            border: '1px solid #FFEEBA',
            borderRadius: '5px',
            padding: '10px',
            color: '#856404',
            fontSize: '13px',
            marginTop: '20px',
            textAlign: 'center',
        },
        actions: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
    };

    return (
        <div style={modalStyles.overlay} onClick={onClose}>
            <div style={modalStyles.modal} onClick={e => e.stopPropagation()}>
                <h3 style={modalStyles.header}>Add New Phone Number</h3>
                <div>
                    <label htmlFor="newNumberSelect" style={styles.label}>Select an available number:</label>
                    <select 
                        id="newNumberSelect" 
                        style={styles.select} 
                        value={selectedNumber} 
                        onChange={e => setSelectedNumber(e.target.value)}
                    >
                        {AVAILABLE_NUMBERS.map(num => (
                            <option key={num} value={num} style={styles.selectOption}>{num}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="newNumberDesc" style={styles.label}>Description</label>
                    <input 
                        type="text" 
                        id="newNumberDesc" 
                        style={styles.input} 
                        value={description} 
                        onChange={e => setDescription(e.target.value)} 
                        placeholder="e.g., Accounts Department" 
                    />
                </div>
                
                <div style={modalStyles.costNote}>
                    <strong>Please Note:</strong> Each additional number costs $30/month and will be added to your subscription.
                </div>

                <div style={modalStyles.actions}>
                    <button style={{ ...styles.button, backgroundColor: '#FFFFFF', color: '#0065FF', border: '1px solid #0065FF' }} onClick={onClose}>Cancel</button>
                    <button style={{ ...styles.button, ...styles.primaryButton }} onClick={handleAdd}>Add Number & Agree</button>
                </div>
            </div>
        </div>
    );
};


// --- Main Component ---
const AccountsReceivableSettings = (props: ARSettingsProps) => {
    const { organizationId } = props.match.params;
    const dispatch = useDispatch();
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    
    const userCookie = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [validationErrors, setValidationErrors] = useState<string[]>([]);
    const [isPlayingPreview, setIsPlayingPreview] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const [advancedSettingsExpanded, setAdvancedSettingsExpanded] = useState(false);


    // --- Settings States ---

    // Standard Settings
    const [collectionsEnabled, setCollectionsEnabled] = useState(true);
    const [selectedVoice, setSelectedVoice] = useState(DEFAULT_VOICE_ID);
    const [personality, setPersonality] = useState(DEFAULT_PERSONALITY_ID);
    const [outboundKnownCustomerGreeting, setOutboundKnownCustomerGreeting] = useState("Hello {customer_name}, this is {agent_name} from {organization_name} regarding your outstanding invoice.");
    const [outboundUnknownCustomerGreeting, setOutboundUnknownCustomerGreeting] = useState("Hello, this is {agent_name} from {organization_name}. Am I speaking with someone from your accounts department?");
    const [incomingKnownCustomerGreeting, setIncomingKnownCustomerGreeting] = useState("Thanks for calling {organization_name}, {customer_name}. How can I help you today?");
    const [incomingUnknownCustomerMessage, setIncomingUnknownCustomerMessage] = useState("Thanks for calling {organization_name}. We specialize in [Your Services Here]. How can I direct your call?");
    const [initialCallDaysPastPaymentTerms, setInitialCallDaysPastPaymentTerms] = useState(7);
    const [enablePreDueDateReminders, setEnablePreDueDateReminders] = useState(false);
    const [reminderDaysBeforeDueDate, setReminderDaysBeforeDueDate] = useState(3);
    const [personalityOverrides, setPersonalityOverrides] = useState<PersonalityOverride[]>([
        { enabled: false, daysPastPaymentTerms: 30, personalityId: DEFAULT_PERSONALITY_ID },
        { enabled: false, daysPastPaymentTerms: 60, personalityId: DEFAULT_PERSONALITY_ID },
        { enabled: false, daysPastPaymentTerms: 90, personalityId: DEFAULT_PERSONALITY_ID },
    ]);
    const [maxAttempts, setMaxAttempts] = useState(5);
    const [storeCallRecordings, setStoreCallRecordings] = useState(true);
    const [recordingAnnouncement, setRecordingAnnouncement] = useState("This call may be recorded for quality assurance and training purposes. By continuing, you consent to this.");
    const [limitCallsByAmountEnabled, setLimitCallsByAmountEnabled] = useState(false);
    const [limitCallsComparisonType, setLimitCallsComparisonType] = useState('greater_than');
    const [limitCallsAmount, setLimitCallsAmount] = useState(100);
    const initialShiftState: Shift = {
        enabled: false, startTime: '09:00', endTime: '17:00',
        voiceId: DEFAULT_VOICE_ID, personalityId: DEFAULT_PERSONALITY_ID,
    };
    const initialTimetable: DaySchedule[] = DAYS_OF_WEEK.map(day => ({
        day,
        shifts: [
            { ...initialShiftState, enabled: day !== 'Saturday' && day !== 'Sunday' },
            { ...initialShiftState, startTime: '13:00', endTime: '17:00' } 
        ]
    }));
    const [timetable, setTimetable] = useState<DaySchedule[]>(initialTimetable);

    // Advanced / Compliance Settings
    const [blackoutDates, setBlackoutDates] = useState('');
    const [maxContactsPerWeek, setMaxContactsPerWeek] = useState(3);
    const [maxContactsPerMonth, setMaxContactsPerMonth] = useState(10);
    const [maxAttemptsPerDay, setMaxAttemptsPerDay] = useState(3);
    const [allowEmailContact, setAllowEmailContact] = useState(true);
    const [allowSmsContact, setAllowSmsContact] = useState(false);
    const [pauseOnDispute, setPauseOnDispute] = useState(true);
    const [pauseOnBankruptcy, setPauseOnBankruptcy] = useState(true);
    const [pauseOnPaymentArrangement, setPauseOnPaymentArrangement] = useState(true);
    const [pauseOnVulnerable, setPauseOnVulnerable] = useState(true);
    const [enableDisputeHardshipWorkflow, setEnableDisputeHardshipWorkflow] = useState(true);
    const [escalationEmail, setEscalationEmail] = useState('');
    const [useVeiledApproach, setUseVeiledApproach] = useState(true);
    const [enableDistressSignalDetection, setEnableDistressSignalDetection] = useState(true);
    const [enablePostCallAuditing, setEnablePostCallAuditing] = useState(true);
    const [sendWrittenConfirmations, setSendWrittenConfirmations] = useState(true);
    const [confirmationTemplate, setConfirmationTemplate] = useState("Dear {customer_name},\n\nThis confirms our recent conversation and the payment arrangement we agreed upon for invoice {invoice_number}.\n\nTerms: {arrangement_terms}\n\nThank you,\n{organization_name}");
    const [checkForStatuteBarredDebts, setCheckForStatuteBarredDebts] = useState(true);
    const [enableHumanEscalationPath, setEnableHumanEscalationPath] = useState(true);
    const [humanEscalationContact, setHumanEscalationContact] = useState('');

    // --- Paste these new state variables with the existing ones ---

    // Communication & Notification Settings
    const [enableEmailReminders, setEnableEmailReminders] = useState(true);
    const [emailReminderFrequency, setEmailReminderFrequency] = useState(7); // e.g., every 7 days
    const [emailReminderSubject, setEmailReminderSubject] = useState("Reminder: Invoice {invoice_number} is overdue");
    const [emailReminderTemplate, setEmailReminderTemplate] = useState("Hi {customer_name},\n\nThis is a friendly reminder that invoice {invoice_number} for the amount of {amount_due} was due on {due_date}. Please let us know if you have any questions.\n\nBest regards,\n{organization_name}");
    const [enableSmsReminders, setEnableSmsReminders] = useState(false);
    const [smsReminderFrequency, setSmsReminderFrequency] = useState(7);
    const [smsReminderTemplate, setSmsReminderTemplate] = useState("Hi {customer_name}, a reminder from {organization_name} that invoice {invoice_number} is overdue. Please contact us to arrange payment.");
    const [enableTodoNotifications, setEnableTodoNotifications] = useState(true);
    const [todoNotificationEmail, setTodoNotificationEmail] = useState('');
    // Where "Payments Received" confirmation emails go (ar_settings.notification_email)
    const [paymentNotificationEmail, setPaymentNotificationEmail] = useState('');


    // Phone Number Settings
    const [primaryPhoneNumber, setPrimaryPhoneNumber] = useState('+61483945713'); // Example
    const [additionalPhoneNumbers, setAdditionalPhoneNumbers] = useState([
    ]);
    const [isAddNumberModalOpen, setIsAddNumberModalOpen] = useState(false);


    // --- Effects ---
    useEffect(() => {
        if (!isUserLoggedIn) {
            props.history.push(STRING_CONSTANTS.navigationString.login);
            return;
        }
        loadSettings();
        if (userCookie?.user?.unreadNotificationCount !== undefined) {
             setUnreadNotificationCount(userCookie.user.unreadNotificationCount);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId, isUserLoggedIn, props.history]);

    const loadSettings = async () => {
        setIsLoading(true);
        try {
            const response = await userService.aiRequest({
                method: 'get-ar-settings', data: { organizationId },
            }, true);

            if (response.data?.settings) {
                let st = response.data.settings;

                // Standard Settings
                setLimitCallsByAmountEnabled(st.limitCallsByAmountEnabled ?? false);
                setLimitCallsComparisonType(st.limitCallsComparisonType || 'greater_than');
                setLimitCallsAmount(st.limitCallsAmount ?? 100);
                setCollectionsEnabled(st.collectionsEnabled ?? true);
                setSelectedVoice(st.aiVoice || DEFAULT_VOICE_ID);
                setPersonality(st.aiPersonality || DEFAULT_PERSONALITY_ID);
                setOutboundKnownCustomerGreeting(st.knownCustomerGreeting || outboundKnownCustomerGreeting);
                setOutboundUnknownCustomerGreeting(st.unknownCustomerGreeting || outboundUnknownCustomerGreeting);
                setIncomingKnownCustomerGreeting(st.incomingKnownCustomerGreeting || incomingKnownCustomerGreeting);
                setIncomingUnknownCustomerMessage(st.incomingUnknownCustomerMessage || incomingUnknownCustomerMessage);
                setInitialCallDaysPastPaymentTerms(st.initialCallDaysPastPaymentTerms ?? 7);
                setEnablePreDueDateReminders(st.enablePreDueDateReminders ?? false);
                setReminderDaysBeforeDueDate(st.reminderDaysBeforeDueDate ?? 3);
                setPrimaryPhoneNumber(st.primaryPhoneNumber || '+61483945713'); // Use a sensible default
                setAdditionalPhoneNumbers(st.additionalPhoneNumbers || []);
                const defaultOverrides = [
                    { enabled: false, daysPastPaymentTerms: 30, personalityId: DEFAULT_PERSONALITY_ID },
                    { enabled: false, daysPastPaymentTerms: 60, personalityId: DEFAULT_PERSONALITY_ID },
                    { enabled: false, daysPastPaymentTerms: 90, personalityId: DEFAULT_PERSONALITY_ID },
                ];

                // Check if valid overrides exist in the saved settings
                if (st.personalityOverrides && Array.isArray(st.personalityOverrides) && st.personalityOverrides.length > 0) {
                    // If they exist, use them directly from the backend data
                    setPersonalityOverrides(st.personalityOverrides);
                } else {
                    // Otherwise, fall back to the default structure
                    setPersonalityOverrides(defaultOverrides);
                }

                setMaxAttempts(st.maxAttempts ?? 5);
                setStoreCallRecordings(st.storeCallRecordings ?? true);
                setRecordingAnnouncement(st.recordingAnnouncement || recordingAnnouncement);
                
                if (st.timetable && Array.isArray(st.timetable) && st.timetable.length === DAYS_OF_WEEK.length) {
                    const isValidTimetable = st.timetable.every(daySchedule => 
                        daySchedule.day && DAYS_OF_WEEK.includes(daySchedule.day) &&
                        Array.isArray(daySchedule.shifts) && daySchedule.shifts.length === 2 &&
                        daySchedule.shifts.every(shift => 
                            typeof shift.enabled === 'boolean' && typeof shift.startTime === 'string' &&
                            typeof shift.endTime === 'string' && AVAILABLE_VOICES.some(v => v.id === shift.voiceId) &&
                            PERSONALITY_TYPES.some(p => p.id === shift.personalityId)
                        )
                    );
                    if (isValidTimetable) setTimetable(st.timetable);
                    else { console.warn("Loaded timetable is invalid, using default."); setTimetable(initialTimetable); }
                } else { setTimetable(initialTimetable); }

                // Advanced / Compliance Settings
                setBlackoutDates(st.blackoutDates ?? '');
                setMaxContactsPerWeek(st.maxContactsPerWeek ?? 3);
                setMaxContactsPerMonth(st.maxContactsPerMonth ?? 10);
                setMaxAttemptsPerDay(st.maxAttemptsPerDay ?? 3);
                setAllowEmailContact(st.allowEmailContact ?? true);
                setAllowSmsContact(st.allowSmsContact ?? false);
                setPauseOnDispute(st.pauseOnDispute ?? true);
                setPauseOnBankruptcy(st.pauseOnBankruptcy ?? true);
                setPauseOnPaymentArrangement(st.pauseOnPaymentArrangement ?? true);
                setPauseOnVulnerable(st.pauseOnVulnerable ?? true);
                setEnableDisputeHardshipWorkflow(st.enableDisputeHardshipWorkflow ?? true);
                setEscalationEmail(st.escalationEmail ?? '');
                setUseVeiledApproach(st.useVeiledApproach ?? true);
                setEnableDistressSignalDetection(st.enableDistressSignalDetection ?? true);
                setEnablePostCallAuditing(st.enablePostCallAuditing ?? true);
                setSendWrittenConfirmations(st.sendWrittenConfirmations ?? true);
                setConfirmationTemplate(st.confirmationTemplate || confirmationTemplate);
                setCheckForStatuteBarredDebts(st.checkForStatuteBarredDebts ?? true);
                setEnableHumanEscalationPath(st.enableHumanEscalationPath ?? true);
                setHumanEscalationContact(st.humanEscalationContact ?? '');

                setEnableEmailReminders(st.enableEmailReminders ?? true);
                setEmailReminderFrequency(st.emailReminderFrequency ?? 7);
                setEmailReminderSubject(st.emailReminderSubject || "Reminder: Invoice {invoice_number} is overdue");
                setEmailReminderTemplate(st.emailReminderTemplate || "Hi {customer_name},\n\nThis is a friendly reminder that invoice {invoice_number} for the amount of {amount_due} was due on {due_date}. Please let us know if you have any questions.\n\nBest regards,\n{organization_name}");
                setEnableSmsReminders(st.enableSmsReminders ?? false);
                setSmsReminderFrequency(st.smsReminderFrequency ?? 7);
                setSmsReminderTemplate(st.smsReminderTemplate || "Hi {customer_name}, a reminder from {organization_name} that invoice {invoice_number} is overdue. Please contact us to arrange payment.");
                setEnableTodoNotifications(st.enableTodoNotifications ?? true);
                setTodoNotificationEmail(st.todoNotificationEmail ?? '');
                setPaymentNotificationEmail(st.notificationEmail ?? '');

            }
        } catch (error) {
            console.error("Failed to load settings:", error);
            ValidationErrorToast("Error", "Failed to load settings. Displaying default values.");
        } finally {
            setIsLoading(false);
        }
    };

    const collectAllSettings = () => ({
        // Standard
        collections_enabled: collectionsEnabled,
        ai_voice: selectedVoice,
        ai_personality: personality,
        known_customer_greeting: outboundKnownCustomerGreeting,
        unknown_customer_greeting: outboundUnknownCustomerGreeting,
        incoming_known_customer_greeting: incomingKnownCustomerGreeting,
        incoming_unknown_customer_message: incomingUnknownCustomerMessage,
        initial_call_days_past_payment_terms: initialCallDaysPastPaymentTerms,
        enable_pre_due_date_reminders: enablePreDueDateReminders,
        reminder_days_before_due_date: reminderDaysBeforeDueDate,
        personality_overrides: personalityOverrides,
        max_attempts: maxAttempts,
        store_call_recordings: storeCallRecordings,
        recording_announcement: recordingAnnouncement,
        timetable: timetable,
        limit_calls_by_amount_enabled: limitCallsByAmountEnabled,
        limit_calls_comparison_type: limitCallsComparisonType,
        limit_calls_amount: limitCallsAmount,
        primary_phone_number: primaryPhoneNumber,
        additional_phone_numbers: additionalPhoneNumbers,
        enable_email_reminders: enableEmailReminders,
        email_reminder_frequency: emailReminderFrequency,
        email_reminder_subject: emailReminderSubject,
        email_reminder_template: emailReminderTemplate,
        enable_sms_reminders: enableSmsReminders,
        sms_reminder_frequency: smsReminderFrequency,
        sms_reminder_template: smsReminderTemplate,
        enable_todo_notifications: enableTodoNotifications,
        todo_notification_email: todoNotificationEmail,
        notification_email: paymentNotificationEmail,

        // Advanced
        blackout_dates: blackoutDates,
        max_contacts_per_week: maxContactsPerWeek,
        max_contacts_per_month: maxContactsPerMonth,
        max_attempts_per_day: maxAttemptsPerDay,
        allow_email_contact: allowEmailContact,
        allow_sms_contact: allowSmsContact,
        pause_on_dispute: pauseOnDispute,
        pause_on_bankruptcy: pauseOnBankruptcy,
        pause_on_payment_arrangement: pauseOnPaymentArrangement,
        pause_on_vulnerable: pauseOnVulnerable,
        enable_dispute_hardship_workflow: enableDisputeHardshipWorkflow,
        escalation_email: escalationEmail,
        use_veiled_approach: useVeiledApproach,
        enable_distress_signal_detection: enableDistressSignalDetection,
        enable_post_call_auditing: enablePostCallAuditing,
        send_written_confirmations: sendWrittenConfirmations,
        confirmation_template: confirmationTemplate,
        check_for_statute_barred_debts: checkForStatuteBarredDebts,
        enable_human_escalation_path: enableHumanEscalationPath,
        human_escalation_contact: humanEscalationContact,
    });


    const validateSettings = (): string[] => {
        const errors: string[] = [];
        if (!outboundKnownCustomerGreeting.includes('{customer_name}') || !outboundKnownCustomerGreeting.includes('{organization_name}')) errors.push("Out. Known Greeting: Must include {customer_name} & {organization_name}.");
        if (!outboundUnknownCustomerGreeting.includes('{organization_name}')) errors.push("Out. Unknown Greeting: Must include {organization_name}.");
        if (!incomingKnownCustomerGreeting.includes('{customer_name}') || !incomingKnownCustomerGreeting.includes('{organization_name}')) errors.push("In. Known Greeting: Must include {customer_name} & {organization_name}.");
        if (!incomingUnknownCustomerMessage.includes('{organization_name}')) errors.push("In. Unknown Message: Must include {organization_name}.");
        
        if (initialCallDaysPastPaymentTerms < 0) errors.push("Days past payment terms for initial call must be 0 or more.");
        if (enablePreDueDateReminders && (reminderDaysBeforeDueDate < 1 || reminderDaysBeforeDueDate > 30)) errors.push("Reminder days before due date must be between 1 and 30.");
        if (maxAttempts < 1 || maxAttempts > 10) errors.push("Max call attempts must be 1-10.");

        if (limitCallsByAmountEnabled && (limitCallsAmount < 0 || limitCallsAmount === null)) errors.push("Limit calls amount must be a positive number.");

        if (paymentNotificationEmail.trim() && !paymentNotificationEmail.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) errors.push("Payment confirmation email address doesn't look valid.");
        // if (enableTodoNotifications && !todoNotificationEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) errors.push("A valid email is required for task notifications.");

        let lastOverrideDays = -1;
        personalityOverrides.forEach((override, index) => {
            if (override.enabled) {
                if (override.daysPastPaymentTerms <= 0) errors.push(`Override ${index + 1}: Days past payment terms must be > 0.`);
                if (override.daysPastPaymentTerms <= lastOverrideDays && lastOverrideDays !== -1) errors.push(`Override ${index + 1}: Days must be greater than previous enabled override's days.`);
                if (!override.personalityId) errors.push(`Override ${index + 1}: Personality must be selected.`);
                lastOverrideDays = override.daysPastPaymentTerms;
            }
        });
        
        if (storeCallRecordings && !recordingAnnouncement.trim()) errors.push("Recording announcement cannot be empty if storing recordings.");

        timetable.forEach((day) => day.shifts.forEach((shift, si) => {
            if (shift.enabled && shift.startTime >= shift.endTime) {
                errors.push(`${day.day} Shift ${si+1}: Start time must be before end time.`);
            }
        }));

        // Advanced Validations
        // if (maxContactsPerWeek < 1 || maxContactsPerWeek > 20) errors.push("Max contacts per week must be between 1 and 20.");
        // if (maxContactsPerMonth < 1 || maxContactsPerMonth > 50) errors.push("Max contacts per month must be between 1 and 50.");
        // if (maxAttemptsPerDay < 1 || maxAttemptsPerDay > 10) errors.push("Max attempts per day (no contact) must be between 1 and 10.");
        // if (enableDisputeHardshipWorkflow && !escalationEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) errors.push("A valid escalation email is required for the dispute workflow.");
        // if (enableHumanEscalationPath && !humanEscalationContact.trim()) errors.push("A contact (phone/email) is required for the human escalation path.");

        return errors;
    };

    const handleSaveSettings = async () => {
        const errors = validateSettings();
        setValidationErrors(errors);
        if (errors.length > 0) {
            errors.slice(0, 3).forEach(error => ValidationErrorToast("Validation Error", error)); 
            return;
        }

        setIsSaving(true);
        try {
            await userService.aiRequest({
                method: 'save-ar-settings',
                data: { organizationId, settings: collectAllSettings() },
            }, true);
            SuccessToast("Success", "Settings saved successfully!");
        } catch (error) {
            console.error("Failed to save settings:", error);
            ValidationErrorToast("Error", `Failed to save settings: ${error.message || 'Unknown error'}`);
        } finally {
            setIsSaving(false);
        }
    };
    
    const handleCollectionsToggleAndSave = async () => {
        const newCollectionsEnabledStatus = !collectionsEnabled;
        setCollectionsEnabled(newCollectionsEnabledStatus);
        setIsSaving(true); 

        try {
            const currentSettingsPayload = {
                ...collectAllSettings(),
                collections_enabled: newCollectionsEnabledStatus,
            };
            await userService.aiRequest({
                method: 'save-ar-settings',
                data: { organizationId, settings: currentSettingsPayload },
            }, true);
            SuccessToast("Success", `Collections ${newCollectionsEnabledStatus ? 'enabled' : 'disabled'}.`);
        } catch (error) {
            console.error("Failed to toggle collections:", error);
            ValidationErrorToast("Error", "Failed to update collections status.");
            setCollectionsEnabled(!newCollectionsEnabledStatus);
        } finally {
            setIsSaving(false);
        }
    };

    // --- PASTE THESE HANDLER FUNCTIONS ---

    const handleAddNumber = (newNumberData) => {
        const newId = additionalPhoneNumbers.length > 0 ? Math.max(...additionalPhoneNumbers.map(n => n.id)) + 1 : 1;
        setAdditionalPhoneNumbers(prev => [...prev, { id: newId, ...newNumberData }]);
    };

    const handleDeleteNumber = (idToDelete) => {
        setAdditionalPhoneNumbers(prev => prev.filter(n => n.id !== idToDelete));
    };

    // --- Event Handlers ---
    const handleVoicePreview = async (voiceIdToPreview) => {
        if (isPlayingPreview && audioRef.current) {
            audioRef.current.pause(); audioRef.current.currentTime = 0; setIsPlayingPreview(false); return;
        }
        setIsPlayingPreview(true);
        try {
            const voiceData = AVAILABLE_VOICES.find(v => v.id === voiceIdToPreview);
            if (!voiceData?.url) throw new Error("Voice sample URL not found.");
            if (audioRef.current) audioRef.current.pause();
            const audio = new Audio(voiceData.url);
            audioRef.current = audio;
            audio.onended = () => setIsPlayingPreview(false);
            audio.onerror = () => { setIsPlayingPreview(false); ValidationErrorToast("Error", "Failed to play voice preview."); };
            await audio.play();
        } catch (error) {
            console.error("Voice preview error:", error); ValidationErrorToast("Error", "Failed to play voice preview."); setIsPlayingPreview(false);
        }
    };

    const handleTimetableChange = (dayIndex: number, shiftIndex: number, field: keyof Shift, value: any) => {
        setTimetable(prev => prev.map((dayS, dIdx) => dIdx === dayIndex ? { ...dayS, shifts: dayS.shifts.map((sh, sIdx) => sIdx === shiftIndex ? { ...sh, [field]: value, ...(field === 'enabled' && value && !sh.voiceId && { voiceId: DEFAULT_VOICE_ID }), ...(field === 'enabled' && value && !sh.personalityId && { personalityId: DEFAULT_PERSONALITY_ID }) } : sh) as [Shift, Shift] } : dayS));
    };

    const handlePersonalityOverrideChange = (index: number, field: keyof PersonalityOverride, value: any) => {
        setPersonalityOverrides(prev => prev.map((override, i) => i === index ? { ...override, [field]: value, ...(field === 'enabled' && value && !override.personalityId && { personalityId: DEFAULT_PERSONALITY_ID }) } : override));
    };
    
    const handleLogout = (e) => {
        e.preventDefault();
        userService.logout()
            .then(() => {
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            })
            .catch((err) => {
                console.error("Logout error:", err);
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            });
    };

    // --- Render ---
    if (isLoading) {
        return <div style={styles.loadingOverlay}><div className="spinner-border" style={{ width: '3rem', height: '3rem', color: '#0065FF' }} role="status"><span className="sr-only">Loading...</span></div></div>;
    }

    return (
        <section className="main-dashboard-wrap" style={styles.container}>
            <Helmet><title>MPLOI: AR Collection Settings</title></Helmet>
            <div id="wrapper" style={{ flexGrow: 1, display: 'flex' }}>
                <ul className={`navbar-nav sidebar sidebar-dark accordion`} id="accordionSidebar" style={{background: '#0065FF', transition: 'none !important', overflowY: 'auto', flexShrink: 0, height: '100vh'}}>
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="#"><img src={UtilityFunctions.getImageURL() + "db-logo.svg"} alt="Logo" /></Link>
                        {userCookie?.user?.isAccountsSignup === false && <li className="nav-item"><Link className="nav-link" to="/ar/affiliate/dashboard"><img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="Home" /><img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="Home Active" /></Link></li>}
                    </div>
                    <div style={{ marginTop: 'auto', paddingBottom: '20px' }}><li className='d-grid justify-content-center gap-2 text-white'><span style={{ cursor: "pointer" }} onClick={handleLogout}>Logout</span></li></div>
                </ul>

                <div id="content-wrapper" className="d-flex flex-column" style={{ flexGrow: 1, overflowY: 'auto' }}>
                    <div id="content">
                        <div style={styles.topBar}>
                            <button style={styles.backButton} onClick={() => props.history.push('/ar')} disabled={isSaving}><span style={{ fontSize: '16px', lineHeight: '1' }}>←</span><span>Dashboard</span></button>
                            <h1 style={styles.topBarTitle}>Collection Settings</h1>
                            <button style={{ ...styles.button, ...styles.primaryButton, padding: '8px 16px', fontSize: '13px' }} onClick={handleSaveSettings} disabled={isSaving || isLoading}>
                                {isSaving ? 'Saving...' : 'Save Settings'}
                            </button>
                        </div>

                        <div className="container-fluid" style={{padding: '0 20px 20px 20px'}}>
                            {validationErrors.length > 0 && (
                                <div style={styles.validationErrorBox}>
                                    <h4 style={{ margin: '0 0 8px 0', fontSize: '15px' }}>Please correct the following errors:</h4>
                                    <ul style={styles.validationErrorList}>{validationErrors.map((e, i) => <li key={i}>{e}</li>)}</ul>
                                </div>
                            )}

                            <div style={{...styles.blueBox, paddingBottom: '10px'}}>
                                <ToggleSwitch label="Automated Collections Enabled" isOn={collectionsEnabled} handleToggle={handleCollectionsToggleAndSave} disabled={isSaving} />
                                <p style={{...styles.mutedText, marginLeft: '0px', marginTop: '4px'}}>MPLOI will automatically manage overdue invoices when enabled.</p>
                            </div>
                            
                            {/* ... [Existing sections: AI Config, Outbound, Incoming, Strategy, Operating Hours, Privacy] ... */}
                            
                            <div style={styles.formRow}>
                                <div style={styles.formCol}>
                                    <div style={styles.blueBox}>
                                        <h3 style={styles.sectionTitle}><span role="img" aria-label="robot">🤖</span> AI Configuration</h3>
                                        <label htmlFor="aiVoice" style={styles.label}>Default AI Voice (Outbound)</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <select id="aiVoice" style={{ ...styles.select, flexGrow: 1, marginBottom: '0px' }} value={selectedVoice} onChange={(e) => setSelectedVoice(e.target.value)} disabled={isSaving}>
                                                {AVAILABLE_VOICES.map(v => <option key={v.id} value={v.id} style={styles.selectOption}>{v.name}</option>)}
                                            </select>
                                            <button style={{ ...styles.button, ...styles.previewButton }} onClick={() => handleVoicePreview(selectedVoice)} disabled={isSaving || isPlayingPreview}>{isPlayingPreview ? '⏹️' : '▶️'}</button>
                                        </div>
                                        <div style={{marginTop: '12px'}}>
                                            <label htmlFor="aiPersonality" style={styles.label}>Default AI Personality (Outbound)</label>
                                            <select id="aiPersonality" style={styles.select} value={personality} onChange={(e) => setPersonality(e.target.value)} disabled={isSaving}>
                                                {PERSONALITY_TYPES.map(t => <option key={t.id} value={t.id} style={styles.selectOption}>{t.name} - {t.description}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div style={styles.formCol}>
                                    <div style={styles.blueBox}>
                                        <h3 style={styles.sectionTitle}><span role="img" aria-label="megaphone">📣</span> Outbound Call Greetings</h3>
                                        <label htmlFor="outboundKnownGreeting" style={styles.label}>Known Customer</label>
                                        <textarea id="outboundKnownGreeting" style={{ ...styles.input, ...styles.textarea }} value={outboundKnownCustomerGreeting} onChange={(e) => setOutboundKnownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px', marginBottom: '8px'}}>Vars: {'{customer_name}'}, {'{agent_name}'}, {'{organization_name}'}</p>
                                        
                                        <label htmlFor="outboundUnknownGreeting" style={styles.label}>Unknown Customer</label>
                                        <textarea id="outboundUnknownGreeting" style={{ ...styles.input, ...styles.textarea }} value={outboundUnknownCustomerGreeting} onChange={(e) => setOutboundUnknownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Vars: {'{agent_name}'}, {'{organization_name}'}</p>
                                    </div>
                                </div>
                            </div>

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="phone receiver">📞</span> Incoming Call Settings</h3>
                                <div style={styles.formRow}>
                                    <div style={styles.formCol}>
                                        <label htmlFor="incomingKnownGreeting" style={styles.label}>Known Caller Message</label>
                                        <textarea id="incomingKnownGreeting" style={{ ...styles.input, ...styles.textarea }} value={incomingKnownCustomerGreeting} onChange={(e) => setIncomingKnownCustomerGreeting(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Vars: {'{customer_name}'}, {'{organization_name}'}</p>
                                    </div>
                                    <div style={styles.formCol}>
                                        <label htmlFor="incomingUnknownMessage" style={styles.label}>Unknown Caller Message</label>
                                        <textarea id="incomingUnknownMessage" style={{ ...styles.input, ...styles.textarea }} value={incomingUnknownCustomerMessage} onChange={(e) => setIncomingUnknownCustomerMessage(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Var: {'{organization_name}'}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="strategy">🎯</span> Outbound Call Strategy</h3>
                                <div style={styles.formRow}>
                                    <div style={styles.formCol}>
                                        <label htmlFor="initialCallDays" style={styles.label}>Initial call if invoice is past payment terms by:</label>
                                        <select id="initialCallDays" style={styles.select} value={initialCallDaysPastPaymentTerms} onChange={(e) => setInitialCallDaysPastPaymentTerms(Number(e.target.value))} disabled={isSaving}>
                                            {[0, 1, 3, 5, 7, 14, 30].map(d => <option key={d} value={d}>{d === 0 ? "Immediately" : `${d} day${d === 1 ? '' : 's'}`}</option>)}
                                        </select>
                                    </div>
                                    <div style={styles.formCol}>
                                        <label htmlFor="maxAttempts" style={styles.label}>Max call attempts per invoice:</label>
                                        <input type="number" id="maxAttempts" style={styles.input} value={maxAttempts} onChange={(e) => setMaxAttempts(Number(e.target.value))} min={1} max={10} disabled={isSaving} />
                                    </div>
                                </div>
                                <div style={{borderTop: '1px solid #E0E0E0', paddingTop: '16px', marginTop: '16px'}}>
                                    <ToggleSwitch
                                        label="Limit calls based on invoice amount"
                                        isOn={limitCallsByAmountEnabled}
                                        handleToggle={() => setLimitCallsByAmountEnabled(!limitCallsByAmountEnabled)}
                                        disabled={isSaving}
                                    />
                                    {limitCallsByAmountEnabled && (
                                        <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                            <p style={{...styles.label, marginBottom: '8px'}}>Only call customers for invoices with an amount...</p>
                                            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                                <select style={{...styles.select, width: 'auto', flexGrow: 1, marginBottom: 0}} value={limitCallsComparisonType} onChange={(e) => setLimitCallsComparisonType(e.target.value)} disabled={isSaving}>
                                                    <option value="greater_than" style={styles.selectOption}>Greater than</option>
                                                    <option value="less_than" style={styles.selectOption}>Less than</option>
                                                </select>
                                                <span style={{...styles.whiteText, fontSize: '16px'}}>$</span>
                                                <input type="number" style={{...styles.input, width: '120px', marginBottom: 0}} value={limitCallsAmount} onChange={(e) => setLimitCallsAmount(Number(e.target.value))} min={0} disabled={isSaving}/>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div style={{marginTop: '12px'}}>
                                    <ToggleSwitch label="Enable pre-due date reminder calls" isOn={enablePreDueDateReminders} handleToggle={() => setEnablePreDueDateReminders(!enablePreDueDateReminders)} disabled={isSaving} />
                                    {enablePreDueDateReminders && (
                                        <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                            <label htmlFor="reminderDays" style={styles.label}>Make reminder call when invoice is due in:</label>
                                            <select id="reminderDays" style={styles.select} value={reminderDaysBeforeDueDate} onChange={(e) => setReminderDaysBeforeDueDate(Number(e.target.value))} disabled={isSaving}>
                                                {PRE_DUE_DATE_REMINDER_OPTIONS.map(d => <option key={d} value={d}>{d} day{d === 1 ? '' : 's'}</option>)}
                                            </select>
                                        </div>
                                    )}
                                </div>
                                <h4 style={{...styles.label, marginTop: '20px', fontSize: '14px', fontWeight: '600'}}>Personality Overrides (based on days past payment terms):</h4>
                                {personalityOverrides.map((override, index) => (
                                    <div key={index} style={styles.overrideTier}>
                                        <ToggleSwitch label={`Enable Override Tier ${index + 1}`} isOn={override.enabled} handleToggle={() => handlePersonalityOverrideChange(index, 'enabled', !override.enabled)} disabled={isSaving} />
                                        {override.enabled && (
                                            <div style={styles.formRow}>
                                                <div style={styles.formCol}>
                                                    <label style={styles.label}>If invoice is &gt; X days past terms:</label>
                                                    <input type="number" style={styles.input} value={override.daysPastPaymentTerms} onChange={e => handlePersonalityOverrideChange(index, 'daysPastPaymentTerms', Number(e.target.value))} min={1} disabled={isSaving} />
                                                </div>
                                                <div style={styles.formCol}>
                                                    <label style={styles.label}>Change personality to:</label>
                                                    <select style={styles.select} value={override.personalityId} onChange={e => handlePersonalityOverrideChange(index, 'personalityId', e.target.value)} disabled={isSaving}>
                                                        {PERSONALITY_TYPES.map(p => <option key={p.id} value={p.id} style={styles.selectOption}>{p.name}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* --- PASTE THIS ENTIRE SECTION INTO YOUR JSX --- */}

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="envelope with arrow">📨</span> Communication & Notifications</h3>
                                
                                <h4 style={styles.subSectionTitle}>Email Reminders</h4>
                                <ToggleSwitch label="Enable Automated Email Reminders" isOn={enableEmailReminders} handleToggle={() => setEnableEmailReminders(!enableEmailReminders)} disabled={isSaving} />
                                {enableEmailReminders && (
                                    <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}>
                                                <label htmlFor="emailReminderFrequency" style={styles.label}>Send reminder every (days after due):</label>
                                                <input type="number" id="emailReminderFrequency" style={styles.input} value={emailReminderFrequency} onChange={(e) => setEmailReminderFrequency(Number(e.target.value))} min={1} max={30} disabled={isSaving} />
                                            </div>
                                            <div style={styles.formCol}>
                                                <label htmlFor="emailReminderSubject" style={styles.label}>Email Subject:</label>
                                                <input type="text" id="emailReminderSubject" style={styles.input} value={emailReminderSubject} onChange={(e) => setEmailReminderSubject(e.target.value)} disabled={isSaving} />
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="emailReminderTemplate" style={styles.label}>Email Body Template:</label>
                                            <textarea id="emailReminderTemplate" style={{ ...styles.input, ...styles.textarea, minHeight: '120px' }} value={emailReminderTemplate} onChange={(e) => setEmailReminderTemplate(e.target.value)} disabled={isSaving} />
                                            <p style={styles.mutedText}>Vars: {'{customer_name}'}, {'{invoice_number}'}, {'{due_date}'}, {'{amount_due}'}, {'{organization_name}'}</p>
                                        </div>
                                    </div>
                                )}


                                <h4 style={{...styles.subSectionTitle, marginTop: '24px'}}>SMS Reminders</h4>
                                <ToggleSwitch label="Enable Automated SMS Reminders" isOn={enableSmsReminders} handleToggle={() => setEnableSmsReminders(!enableSmsReminders)} disabled={isSaving} />
                                {enableSmsReminders && (
                                    <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}>
                                                <label htmlFor="smsReminderFrequency" style={styles.label}>Send reminder every (days after due):</label>
                                                <input type="number" id="smsReminderFrequency" style={styles.input} value={smsReminderFrequency} onChange={(e) => setSmsReminderFrequency(Number(e.target.value))} min={1} max={30} disabled={isSaving} />
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="smsReminderTemplate" style={styles.label}>SMS Message Template:</label>
                                            <textarea id="smsReminderTemplate" style={{ ...styles.input, ...styles.textarea, minHeight: '60px' }} value={smsReminderTemplate} onChange={(e) => setSmsReminderTemplate(e.target.value)} disabled={isSaving} maxLength={160}/>
                                            <p style={styles.mutedText}>Keep it concise! Vars: {'{customer_name}'}, {'{invoice_number}'}, {'{amount_due}'}, {'{organization_name}'}</p>
                                            <p style={styles.mutedText}>Note: Requires an active SMS provider integration on your account.</p>
                                        </div>
                                    </div>
                                )}

                                <h4 style={{...styles.subSectionTitle, marginTop: '24px'}}>Task Notifications</h4>
                                <ToggleSwitch label="Enable Notifications for Required Actions" isOn={enableTodoNotifications} handleToggle={() => setEnableTodoNotifications(!enableTodoNotifications)} disabled={isSaving} />
                                <p style={styles.mutedText}>Sends an email when an action is required, like a transaction dispute or a request for hardship consideration.</p>
                                {enableTodoNotifications && (
                                    <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                        <label htmlFor="todoNotificationEmail" style={styles.label}>Send Notifications To:</label>
                                        <input type="email" id="todoNotificationEmail" placeholder="accounts@yourcompany.com" style={styles.input} value={todoNotificationEmail} onChange={(e) => setTodoNotificationEmail(e.target.value)} disabled={isSaving} />
                                    </div>
                                )}

                                <h4 style={{...styles.subSectionTitle, marginTop: '24px'}}>Payment Notifications</h4>
                                <p style={styles.mutedText}>When a customer we've been chasing pays, we'll email a confirmation listing the invoices paid and our call history with them. Leave blank to turn these off.</p>
                                <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                    <label htmlFor="paymentNotificationEmail" style={styles.label}>Send Payment Confirmations To:</label>
                                    <input type="email" id="paymentNotificationEmail" placeholder="accounts@yourcompany.com" style={styles.input} value={paymentNotificationEmail} onChange={(e) => setPaymentNotificationEmail(e.target.value)} disabled={isSaving} />
                                </div>
                            </div>

                            {/* --- NEW ADVANCED SETTINGS SECTION --- */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.sectionTitle, ...styles.collapsibleSectionTitle}} onClick={() => setAdvancedSettingsExpanded(!advancedSettingsExpanded)}>
                                    <span style={{...styles.arrowIcon, ...(advancedSettingsExpanded && styles.arrowIconExpanded)}}>▶</span>
                                    <span role="img" aria-label="gears">⚙️</span> Compliance & Governance (Advanced)
                                </h3>
                                {advancedSettingsExpanded && (
                                    <div style={{paddingTop: '10px'}}>
                                        
                                        <h4 style={styles.subSectionTitle}>Contact Governance</h4>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}>
                                                <label htmlFor="maxContactsPerWeek" style={styles.label}>Max successful contacts per week:</label>
                                                <input type="number" id="maxContactsPerWeek" style={styles.input} value={maxContactsPerWeek} onChange={(e) => setMaxContactsPerWeek(Number(e.target.value))} min={1} max={20} disabled={isSaving} />
                                            </div>
                                            <div style={styles.formCol}>
                                                <label htmlFor="maxContactsPerMonth" style={styles.label}>Max successful contacts per month:</label>
                                                <input type="number" id="maxContactsPerMonth" style={styles.input} value={maxContactsPerMonth} onChange={(e) => setMaxContactsPerMonth(Number(e.target.value))} min={1} max={50} disabled={isSaving} />
                                            </div>
                                        </div>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}>
                                                <label htmlFor="maxAttemptsPerDay" style={styles.label}>Max attempts in 24h (no contact):</label>
                                                <input type="number" id="maxAttemptsPerDay" style={styles.input} value={maxAttemptsPerDay} onChange={(e) => setMaxAttemptsPerDay(Number(e.target.value))} min={1} max={10} disabled={isSaving} />
                                            </div>
                                            <div style={styles.formCol}>
                                                <label htmlFor="blackoutDates" style={styles.label}>Blackout Dates (e.g., 2024-12-25, 2025-01-01)</label>
                                                <input type="text" id="blackoutDates" placeholder="Comma-separated dates" style={styles.input} value={blackoutDates} onChange={(e) => setBlackoutDates(e.target.value)} disabled={isSaving} />
                                            </div>
                                        </div>
                                        <div style={{borderTop: '1px solid #E0E0E0', marginTop: '12px', paddingTop: '12px'}}>
                                            <ToggleSwitch label="Allow Email as a Contact Channel" isOn={allowEmailContact} handleToggle={() => setAllowEmailContact(!allowEmailContact)} disabled={isSaving} />
                                            <ToggleSwitch label="Allow SMS as a Contact Channel" isOn={allowSmsContact} handleToggle={() => setAllowSmsContact(!allowSmsContact)} disabled={isSaving} />
                                            <p style={styles.mutedText}>Note: Per-customer channel opt-outs are managed on the customer's record.</p>
                                        </div>

                                        <h4 style={styles.subSectionTitle}>Automated Safeguards</h4>
                                        <p style={styles.infoText}>Automatically pause collections for accounts with the following flags:</p>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}><ToggleSwitch label="Liability Disputed" isOn={pauseOnDispute} handleToggle={() => setPauseOnDispute(!pauseOnDispute)} disabled={isSaving} /></div>
                                            <div style={styles.formCol}><ToggleSwitch label="Bankrupt / Insolvent" isOn={pauseOnBankruptcy} handleToggle={() => setPauseOnBankruptcy(!pauseOnBankruptcy)} disabled={isSaving} /></div>
                                        </div>
                                        <div style={styles.formRow}>
                                            <div style={styles.formCol}><ToggleSwitch label="Payment Arrangement in Place" isOn={pauseOnPaymentArrangement} handleToggle={() => setPauseOnPaymentArrangement(!pauseOnPaymentArrangement)} disabled={isSaving} /></div>
                                            <div style={styles.formCol}><ToggleSwitch label="Debtor Marked as Vulnerable" isOn={pauseOnVulnerable} handleToggle={() => setPauseOnVulnerable(!pauseOnVulnerable)} disabled={isSaving} /></div>
                                        </div>
                                        <div style={{marginTop: '12px'}}>
                                            <ToggleSwitch label="Proactively Check for Statute-Barred Debts" isOn={checkForStatuteBarredDebts} handleToggle={() => setCheckForStatuteBarredDebts(!checkForStatuteBarredDebts)} disabled={isSaving} />
                                            <p style={styles.mutedText}>Prevents contact for debts past the legal limitation period.</p>
                                        </div>

                                        <h4 style={styles.subSectionTitle}>AI Behavior & Workflows</h4>
                                        <ToggleSwitch label="Use 'Veiled Approach' for Initial Contact" isOn={useVeiledApproach} handleToggle={() => setUseVeiledApproach(!useVeiledApproach)} disabled={isSaving} />
                                        <p style={styles.mutedText}>Requires meticulous identity verification before disclosing the nature of the call.</p>
                                        <ToggleSwitch label="Enable Real-time Debtor Distress Signal Detection" isOn={enableDistressSignalDetection} handleToggle={() => setEnableDistressSignalDetection(!enableDistressSignalDetection)} disabled={isSaving} />
                                        <p style={styles.mutedText}>AI will monitor language and tone for signs of distress and can trigger escalations.</p>
                                        <ToggleSwitch label="Enable Post-Call Transcript Auditing" isOn={enablePostCallAuditing} handleToggle={() => setEnablePostCallAuditing(!enablePostCallAuditing)} disabled={isSaving} />
                                        <p style={styles.mutedText}>Automatically flags calls for review based on compliance keywords or sentiment.</p>
                                        
                                        <h4 style={styles.subSectionTitle}>Workflows & Escalation</h4>
                                        <ToggleSwitch label="Enable Dispute and Hardship Workflow" isOn={enableDisputeHardshipWorkflow} handleToggle={() => setEnableDisputeHardshipWorkflow(!enableDisputeHardshipWorkflow)} disabled={isSaving} />
                                        {enableDisputeHardshipWorkflow && (
                                            <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                                <label htmlFor="escalationEmail" style={styles.label}>Dispute/Hardship Escalation Email:</label>
                                                <input type="email" id="escalationEmail" placeholder="compliance@example.com" style={styles.input} value={escalationEmail} onChange={(e) => setEscalationEmail(e.target.value)} disabled={isSaving} />
                                            </div>
                                        )}
                                        <div style={{marginTop: '12px'}}>
                                            <ToggleSwitch label="Enable 'Human-in-the-Loop' Escalation Path" isOn={enableHumanEscalationPath} handleToggle={() => setEnableHumanEscalationPath(!enableHumanEscalationPath)} disabled={isSaving} />
                                            {enableHumanEscalationPath && (
                                                <div style={{paddingLeft: '20px', marginTop: '8px'}}>
                                                    <label htmlFor="humanEscalationContact" style={styles.label}>Human Agent Contact (Phone or Email):</label>
                                                    <input type="text" id="humanEscalationContact" placeholder="e.g., 0437482000" style={styles.input} value={humanEscalationContact} onChange={(e) => setHumanEscalationContact(e.target.value)} disabled={isSaving} />
                                                </div>
                                            )}
                                        </div>
                                        <div style={{marginTop: '12px'}}>
                                            <ToggleSwitch label="Send Automated Written Confirmations" isOn={sendWrittenConfirmations} handleToggle={() => setSendWrittenConfirmations(!sendWrittenConfirmations)} disabled={isSaving} />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="telephone">☎️</span> Phone Numbers</h3>
                                
                                <div>
                                    <label style={{...styles.label, fontSize: '14px'}}>Primary Outbound & Inbound Number</label>
                                    <p style={{
                                        ...styles.whiteText, 
                                        fontSize: '18px', 
                                        fontWeight: 'bold', 
                                        background: 'rgba(0,0,0,0.2)', 
                                        padding: '8px 12px', 
                                        borderRadius: '5px', 
                                        display: 'inline-block',
                                        letterSpacing: '1px',
                                        marginBottom: '20px'
                                    }}>
                                        {primaryPhoneNumber}
                                    </p>
                                    <p style={styles.mutedText}>This is the main number used for making calls and shown to your customers.</p>
                                </div>
                            </div>
{/* 
                                <div style={{borderTop: '1px solid #E0E0E0', paddingTop: '20px'}}>
                                    <label style={{...styles.label, fontSize: '14px'}}>Additional Numbers</label>
                                    <p style={styles.mutedText}>Add other numbers your customers can reach you on. Inbound calls will be routed here.</p>
                                    
                                    <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '10px'}}>
                                        <thead>
                                            <tr style={{borderBottom: '2px solid #E0E0E0'}}>
                                                <th style={{...styles.label, padding: '8px 0', textAlign: 'left'}}>Number</th>
                                                <th style={{...styles.label, padding: '8px 0', textAlign: 'left'}}>Description</th>
                                                <th style={{...styles.label, padding: '8px 0', textAlign: 'right'}}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {additionalPhoneNumbers.length > 0 ? (
                                                additionalPhoneNumbers.map(phone => (
                                                    <tr key={phone.id} style={{borderBottom: '1px solid #E0E0E0'}}>
                                                        <td style={{...styles.whiteText, padding: '10px 0', fontSize: '13px'}}>{phone.number}</td>
                                                        <td style={{...styles.whiteText, padding: '10px 0', fontSize: '13px'}}>{phone.description}</td>
                                                        <td style={{padding: '10px 0', textAlign: 'right'}}>
                                                            <button 
                                                                onClick={() => handleDeleteNumber(phone.id)}
                                                                style={{...styles.button, backgroundColor: 'rgba(220, 53, 69, 0.2)', color: '#f8d7da', padding: '4px 8px', fontSize: '12px'}}
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={3} style={{...styles.mutedText, padding: '20px 0', textAlign: 'center', fontStyle: 'italic'}}>
                                                        No additional numbers have been added.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '20px'}}>
                                        <button 
                                            style={{...styles.button, ...styles.primaryButton}} 
                                            onClick={() => setIsAddNumberModalOpen(true)}
                                            disabled={isSaving}
                                        >
                                            + Add New Number
                                        </button>
                                    </div>
                                </div>
                            </div>
*/}

                            {/* --- PASTE THIS LINE AT THE VERY END, BEFORE THE CLOSING </section> TAG --- */}
                            <AddNumberModal isOpen={isAddNumberModalOpen} onClose={() => setIsAddNumberModalOpen(false)} onAdd={handleAddNumber} />
                                

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="clock">⏰</span> Operating Hours</h3>
                                <p style={styles.infoText}>Define when MPLOI is active. Times are based on your organization's timezone.</p>
                                {timetable.map((daySchedule, dayIndex) => (
                                    <div key={daySchedule.day} style={styles.timetableDayRow}>
                                        <div style={styles.timetableDayLabel}>{daySchedule.day}</div>
                                        <div style={styles.timetableShiftsWrapper}>
                                            {daySchedule.shifts.map((shift, shiftIndex) => (
                                                <div key={shiftIndex} style={styles.timetableShiftContainer}>
                                                    <div style={styles.timetableShiftHeader}>
                                                        <span style={{...styles.whiteText, fontWeight: 500, fontSize: '13px'}}>Shift {shiftIndex + 1}</span>
                                                        <ToggleSwitch isOn={shift.enabled} handleToggle={() => handleTimetableChange(dayIndex, shiftIndex, 'enabled', !shift.enabled)} disabled={isSaving} label={shift.enabled ? "Active" : "Inactive"} />
                                                    </div>
                                                    {shift.enabled && (
                                                        <div style={styles.timetableShiftControls}>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Start</label><input type="time" style={styles.timeInput} value={shift.startTime} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'startTime', e.target.value)} disabled={isSaving} /></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>End</label><input type="time" style={styles.timeInput} value={shift.endTime} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'endTime', e.target.value)} disabled={isSaving} /></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Voice</label><select style={{...styles.select, marginBottom: 0, padding: '6px 8px'}} value={shift.voiceId} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'voiceId', e.target.value)} disabled={isSaving}>{AVAILABLE_VOICES.map(v => <option key={v.id} value={v.id} style={styles.selectOption}>{v.name}</option>)}</select></div>
                                                            <div><label style={{...styles.label, fontSize: '12px'}}>Personality</label><select style={{...styles.select, marginBottom: 0, padding: '6px 8px'}} value={shift.personalityId} onChange={e => handleTimetableChange(dayIndex, shiftIndex, 'personalityId', e.target.value)} disabled={isSaving}>{PERSONALITY_TYPES.map(p => <option key={p.id} value={p.id} style={styles.selectOption}>{p.name}</option>)}</select></div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div style={styles.blueBox}>
                                <h3 style={styles.sectionTitle}><span role="img" aria-label="shield">🛡️</span> Privacy & Recordings</h3>
                                <ToggleSwitch label="Store Call Recordings" isOn={storeCallRecordings} handleToggle={() => setStoreCallRecordings(!storeCallRecordings)} disabled={isSaving} />
                                {storeCallRecordings && (
                                    <div style={{ marginTop: '12px' }}>
                                        <label htmlFor="recordingAnnouncement" style={styles.label}>Recording Announcement Message</label>
                                        <textarea id="recordingAnnouncement" style={{ ...styles.input, ...styles.textarea }} value={recordingAnnouncement} onChange={(e) => setRecordingAnnouncement(e.target.value)} disabled={isSaving} />
                                        <p style={{...styles.mutedText, marginTop: '-8px'}}>Played at the start of recorded calls. Ensure compliance.</p>
                                    </div>
                                )}
                            </div>

                            <div style={styles.saveButtonContainer}>
                                <button style={{ ...styles.button, ...styles.primaryButton, padding: '10px 24px', fontSize: '14px' }} onClick={handleSaveSettings} disabled={isSaving || isLoading}>
                                    {isSaving ? 'Saving...' : 'Save All Settings'}
                                </button>
                            </div>
                        </div> 
                    </div> 
                </div> 
            </div> 
            {isSaving && <div style={styles.loadingOverlay}><div className="spinner-border" style={{ width: '3rem', height: '3rem', color: '#0065FF' }} role="status"><span className="sr-only">Saving...</span></div></div>}
            <ARAssistant organizationId={organizationId} accountId={userCookie?.id} />
        </section>
    );
};

export default AccountsReceivableSettings;
